const TIMEOUT = 2000;

import gsap from 'gsap';
import { Basics, isTouch } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { ScrollItem__BlockDefault } from './ScrollItem__BlockDefault';

class ScrollItem__BlockGif extends ScrollItem__BlockDefault {
  // gif = [];
  currentFrame = 0;
  interval = null;

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);
  }

  setAnimations() {
    this.gif = GetBy.selector('.__img figure', this.item);
    super.setAnimations();
  }

  showFunction() {
    super.showFunction();
    this.startGif();
  }

  hideFunction() {
    super.hideFunction();
    this.stopGif();
  }

  startGif() {
    if (this.gif.length === 0) return;
    this.stopGif();

    gsap.set(this.gif[this.currentFrame], { autoAlpha: 1 });

    this.interval = setInterval(() => {
      gsap.set(this.gif[this.currentFrame], { opacity: 0 });
      this.currentFrame = (this.currentFrame + 1) % this.gif.length;
      gsap.set(this.gif[this.currentFrame], { opacity: 1 });
    }, TIMEOUT);
  }

  stopGif() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  dispose() {
    this.stopGif();
    super.dispose();
  }
}

Scroll._registerClass('BlockGif', ScrollItem__BlockGif);
